<template>
  <div class="mobile_container">
    <div class="mobile_banner" @click="console">
      <img class="backimg" src="../../../static/common/nky_sliderbar_personal_portrait.png" width="42"/>
      <div class="shade">
        <p>设备总数</p>
        <p>{{SensorTotal + ControllerTotal + CameraTotal}}</p>
        <p>
          预警次数:<span>（12次）</span>
        </p>
        <div class="bottom">
          <ul>
            <li>
              <div class="content fl">
                <p>传感器</p>
                <p>
                  <span>
                  <img src="../../assets/img/m/online.png" alt="">
                  {{SensorTotalActive}}
                  </span>
                  <span>
                    <img src="../../assets/img/m/offline.png" alt="">
                    {{SensorTotal - SensorTotalActive}}
                  </span>
                </p>
              </div>
              <div class="line fl"></div>
            </li>
            <li>
              <div class="content fl">
                <p>控制器</p>
                <p>
                  <span>
                  <img src="../../assets/img/m/online.png" alt="">
                  {{ControllerTotalActive}}
                  </span>
                  <span>
                    <img src="../../assets/img/m/offline.png" alt="">
                    {{ControllerTotal - ControllerTotalActive}}
                  </span>
                </p>
              </div>
              <div class="line fl"></div>
            </li>
            <li>
              <div class="content fl">
                <p>视频</p>
                <p>
                  <span>
                  <img src="../../assets/img/m/online.png" alt="">
                  {{CameraTotalActive}}
                  </span>
                  <span>
                    <img src="../../assets/img/m/offline.png" alt="">
                    {{CameraTotal - CameraTotalActive}}
                  </span>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="groupList">
      <div class="groupBlock" v-for="item in groupList" @click="groupDetail(item.Id,item.GroupName)">
        <p class="groupTitle">
          <span class="line groupTitleSon"></span>
          <span class="titleText groupTitleSon">&nbsp;{{item.GroupName}}&nbsp;</span>
          <span class="groupTitleSon">&nbsp;今日报警&nbsp;<span>0</span>次</span>
        </p>
        <ul>
          <li>
            <div class="content">
              <p>传感器</p>
              <p>
                  <span>
                  <img src="../../assets/img/m/online.png" alt="">
                  {{item.SensorTotalActive}}
                  </span>
                <span>
                    <img src="../../assets/img/m/offline.png" alt="">
                    {{item.SensorTotal - item.SensorTotalActive}}
                  </span>
              </p>
            </div>
          </li>
          <li>
            <div class="content">
              <p>控制器</p>
              <p>
                  <span>
                  <img src="../../assets/img/m/online.png" alt="">
                  {{item.ControllerTotalActive}}
                  </span>
                <span>
                    <img src="../../assets/img/m/offline.png" alt="">
                    {{item.ControllerTotal - item.ControllerTotalActive}}
                  </span>
              </p>
            </div>
          </li>
          <li>
            <div class="content">
              <p>视频</p>
              <p>
                  <span>
                  <img src="../../assets/img/m/online.png" alt="">
                  {{item.CameraTotalActive}}
                  </span>
                <span>
                    <img src="../../assets/img/m/offline.png" alt="">
                    {{item.CameraTotal - item.CameraTotalActive}}
                  </span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '@/config.js'

  export default {
    name: 'index',
    components: {},
    data() {
      return {
        baseUrl: config("baseServerUrl", "."),
        groupList: [],
        SensorTotal: 0,
        SensorTotalActive: 0,
        ControllerTotal: 0,
        ControllerTotalActive: 0,
        CameraTotal: 0,
        CameraTotalActive: 0,
      }
    },
    mounted: function () {
    },
    created: function () {
      this.getGroupList()
    },
    methods: {
      console() {
        console.log('groupList', this.groupList)
      },
      getGroupList() {
        let url = this.baseUrl + 'api/devicegroup/getlist'
        this.$http.post(url, {
          "PageIndex": 0,
          "PageSize": 99999,
          "SortString": "",
          "SearchString": ""
        }).then(res => {
          this.groupList = res.data.Data.DataList || []

          this.SensorTotal = 0
          this.SensorTotalActive = 0
          this.ControllerTotal = 0
          this.ControllerTotalActive = 0
          this.CameraTotal = 0
          this.CameraTotalActive = 0
          for (var i = 0; i < this.groupList.length; i++) {
            this.SensorTotal += this.groupList[i].SensorTotal
            this.SensorTotalActive += this.groupList[i].SensorTotalActive
            this.ControllerTotal += this.groupList[i].ControllerTotal
            this.ControllerTotalActive += this.groupList[i].ControllerTotalActive
            this.CameraTotal += this.groupList[i].CameraTotal
            this.CameraTotalActive += this.groupList[i].CameraTotalActive
          }
        }).catch(error => {
          this.$Message.error('查询失败，'+ error.message)
        })
      },
      groupDetail(Id, Name) {
        this.$router.push({
          path: 'mpGroupDetail',
          query: {
            GroupId: Id,
            GroupName: Name,
          },
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  .mobile_container {
    background: #F3F7F8;
    .mobile_banner {
      width: 100%;
      height: 4.24rem;
      background: url("../../assets/img/m/banner1.jpg");
      background-size: 100% 100%;
      .shade {
        width: 100%;
        height: 4.24rem;
        position: absolute;
        top: 0;
        background: rgba(17, 36, 66, 0.87843137254902);
        p {
          margin-top: 0.56rem;
          font-family: '微软雅黑';
          font-weight: 400;
          font-style: normal;
          font-size: 0.26rem;
          color: rgba(255, 255, 255, 0.647058823529412);
          text-align: center;
          &:nth-child(2) {
            margin-top: 0.14rem;
            font-size: 0.72rem;
            color: white;
          }
          &:nth-child(3) {
            margin-top: 0.14rem;
            span {
              color: white;
            }
          }
        }
        .bottom {
          width: 100%;
          height: 1.30rem;
          position: absolute;
          bottom: 0px;
          background: rgba(255, 255, 255, 0.129411764705882);
          ul {
            li {
              div.content {
                width: 32.8%;
                height: 1.3rem;
                p {
                  margin-top: 0.1rem;
                  font-family: '微软雅黑';
                  font-weight: 400;
                  font-style: normal;
                  font-size: 0.32rem;
                  color: #FFFFFF;
                  img {
                    width: 0.26rem;
                  }
                }
              }
              div.line {
                margin-top: 0.16rem;
                width: 0.5%;
                height: 1rem;
                background: #576479;
              }
            }
          }
        }
      }
      img.backimg {
        position: absolute;
        z-index: 2;
        top: 0.28rem;
        right: 0.36rem;
        width: 0.5rem;
      }
    }

    .groupList {
      width: 100%;
      .groupBlock {
        margin: 0.2rem 0;
        background: white;
        p.groupTitle {
          padding: 0.2rem 0.16rem;
          border-bottom: solid 0.01rem #E9E9E9;
          span.groupTitleSon {
            &:nth-child(1) {
              position: relative;
              top: 0.03rem;
              display: inline-block;
              width: 0.08rem;
              height: 0.32rem;
              background: rgba(0, 156, 205, 1);
            }
            &:nth-child(2) {
              font-family: '微软雅黑';
              font-weight: 700;
              font-style: normal;
              font-size: 0.34rem;
              color: rgba(51, 51, 51, 0.847058823529412);
            }
            &:nth-child(3) {
              color: rgba(51, 51, 51, 0.647058823529412);
              font-family: '微软雅黑';
              font-weight: 400;
              font-style: normal;
              font-size: 0.26rem;
              span {
                color: rgba(255, 0, 0, 0.647058823529412);
              }
            }
          }
        }

        ul {
          background: white;
          overflow: hidden;
          li {
            border-right: solid 0.01rem #E9E9E9;
            float: left;
            width: 33%;
            &:last-child {
              border: none;
            }
            div.content {
              p {
                font-family: '微软雅黑';
                font-weight: 400;
                font-style: normal;
                font-size: 0.32rem;
                color: rgba(51, 51, 51, 0.847058823529412);
                text-align: center;
                padding: 0.2rem 0.3rem;
                img {
                  width: 0.26rem;
                }
              }
            }
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/mobile/index.vue